import { useCallback, useState } from 'react';
import {
  categoryKeys,
  DEFAULT_APP_DEFAULTS,
  readAppDefaults,
  sanitizeAppDefaults,
  storeAppDefaults,
  type AppDefaults,
  type DefaultCategoryId,
} from './app-defaults-model';

export function useAppDefaults() {
  const [defaults, setDefaults] = useState<AppDefaults>(() => readAppDefaults());

  const update = useCallback((patch: Partial<AppDefaults>) => {
    setDefaults((current) => {
      const next = sanitizeAppDefaults({ ...current, ...patch });
      storeAppDefaults(next);
      return next;
    });
  }, []);

  const resetCategory = useCallback((category: DefaultCategoryId) => {
    setDefaults((current) => {
      const patch = categoryKeys(category).reduce<Partial<AppDefaults>>((acc, key) => {
        acc[key] = DEFAULT_APP_DEFAULTS[key] as never;
        return acc;
      }, {});
      const next = sanitizeAppDefaults({ ...current, ...patch });
      storeAppDefaults(next);
      return next;
    });
  }, []);

  return { defaults, update, resetCategory };
}
